export default __webpack_public_path__ + "static/media/UTENTE_questionario-3.1f0faa26.png";